<template>
  <div class="news" v-if="news">
    <div class="title">
      <p>News Center</p>
      <h2>新闻中心</h2>
    </div>
    <div class="news-container">
      <el-row :gutter="0">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <div class="info-lf" @click="link(post.index)">
            <div class="info-img"><img :src="post.cover" class="img"></div>
            <h1>{{post.title}}</h1>
            <p v-html="post.brief"></p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <div class="info-rg">
            <div
              class="list list-margin"
              v-for="(item,index) in tableData"
              :key="index"
              @click="handleChange(index)"
            >
              <div class="item">
                <p class="number">{{item.d}}</p>
                <p>{{item.m}}月</p>
              </div>
              <div class="info">
                <h1>{{item.title}}</h1>
                <p class="brief">{{item.brief}}</p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="btn">
      <el-button type="warning" @click="handleContact">了解更多 ></el-button>
    </div>
</div>
</template>

<script>
export default {
  name: "News",
  data() {
    return {
      tableData: [],
      post: {},
      news:true
    };
  },
  created() {
    let _this = this;
    this.$http
      .post("/api/api.php?act=getPosts")
      .then(data => {
        if (data.data.code == 200) {
          if(data.data.data.length==0){
            _this.news=false
          }else{_this.news=true}
          data.data.data.forEach((element, index) => {
            if (index == 0) {
              _this.post = element;
            }
            if (index > 0 && index < 4) {
              _this.tableData.push(element);
            }
          });

          _this.tableData.forEach((element, index) => {
            _this.tableData[index].m = element.release_time.substr(5, 2);
            _this.tableData[index].d = element.release_time.substr(8, 2);
            if (_this.tableData[index].m == "01") {
              _this.tableData[index].m = "一";
            }

            if (_this.tableData[index].m == "02") {
              _this.tableData[index].m = "二";
            }

            if (_this.tableData[index].m == "03") {
              _this.tableData[index].m = "三";
            }

            if (_this.tableData[index].m == "04") {
              _this.tableData[index].m = "四";
            }

            if (_this.tableData[index].m == "05") {
              _this.tableData[index].m = "五";
            }

            if (_this.tableData[index].m == "06") {
              _this.tableData[index].m = "六";
            }

            if (_this.tableData[index].m == "07") {
              _this.tableData[index].m = "七";
            }

            if (_this.tableData[index].m == "08") {
              _this.tableData[index].m = "八";
            }

            if (_this.tableData[index].m == "09") {
              _this.tableData[index].m = "九";
            }

            if (_this.tableData[index].m == "10") {
              _this.tableData[index].m = "十";
            }
            if (_this.tableData[index].m == "11") {
              _this.tableData[index].m = "十一";
            }
            if (_this.tableData[index].m == "12") {
              _this.tableData[index].m = "十二";
            }
          });
        } else {
          this.$message(data.data.msg);
        }
      });
  },
  methods: {
    handleContact() {
      this.$router.push({ path: "/news" });
    },
    handleChange(index) {
      let _this = this;
      let id = _this.tableData[index].id;
      this.$router.push({ name: "detail", params: { id: id } });
    },
    link(index) {
      let _this = this;
      let id = _this.post.id;
      this.$router.push({ name: "detail", params: { id: id } });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  text-align: center;
  margin: 0 0 20px;
}
.news {
  width: 1000px;
  margin: 0 auto;
  padding: 30px;
  .title {
    text-align: center;
    margin-top: 0px;
    p {
      color: #f7a527;
      text-transform: uppercase;
      letter-spacing: 2px;
      word-spacing: 10px;
      font-size: 12px;
      line-height: 20px;
    }
    h2 {
      color: #666666;
      letter-spacing: 10px;
      margin-top: 10px;
    }
  }
  .news-container {
    padding: 35px 0;
    .info-lf {
      padding: 10px;
      cursor: pointer;
      .info-img{width: 80%;height: 210px;}
      .img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
      }
      h1 {
        font-size: 20px;
        color: #666;
        line-height: 50px;
        margin: 0;
        padding-right: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        color: #666;
        font-size: 16px;
        line-height: 26px;
        padding-right: 60px;
      }
    }
    .info-rg {
      cursor: pointer;
      padding: 0;
      display: flex;
      flex-direction: column;
      p {
        font-size: 20px;
      }
      .list-margin {
        margin: 12px 0;
      }
      .list {
        display: flex;
        box-shadow: #eee 0px 0px 5px;
        .item {
          background-color: #e9ebf0;
          text-align: center;
          white-space: nowrap;
          color: #2f32a8;
          padding: 10px 16px;
          margin-right: 20px;
          .number {
            font-size: 26px;
          }
        }
        .info {
          // flex: 10;
          margin: 10px 10px 10px 0;
          width: 80%;
          h1 {
            font-size: 18px;
            color: #333;
            white-space: nowrap;
            width: 100%;
            overflow: hidden;

            text-overflow: ellipsis;
          }
          p {
            font-size: 14px;
            color: #666;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            /* autoprefixer: off */
            -webkit-box-orient: vertical;
            /* autoprefixer: on */
            -webkit-line-clamp: 2;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .news {
    width: 100%;
    padding: 0;
    .title {
      margin-top: 30px;
    }
    .news-container {
      padding: 0;
      .el-row {
        margin-left: 0px !important;
        margin-right: 0px !important;
        .el-col {
          padding-left: 0px !important;
          padding-right: 0px !important;
        }
      }
      .info-lf {
        padding: 10px 20px;
        .info-img{width: 100%;height: auto;}
        .img {
          width: 100%;
        }
        h1 {
          font-size: 18px;
          line-height: 24px;
          margin: 10px 0;
          padding-right: 0px;
        }
        p {
          font-size: 14px;
          padding-right: 0px;
        }
      }
      .info-rg {
        padding: 10px;
        .list-margin {
          margin: 26px 0;
        }
        .list {
          .item {
            padding: 22px;
          }
          .info {
            width: 68%;
          }
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/technology/news.vue